/* global Buffer */
import Kithara from "src/services/kithara";
const kithara = new Kithara();

function JWT() {}

JWT.login = function(username, password) {
  return kithara.login(username, password).then(response => {
    return localStorage.setItem("kithara.token", response.data.token);
  });
};

JWT.logout = function() {
  const token = localStorage.removeItem("kithara.token");
  return Promise.resolve(token);
};

JWT.isLoggedIn = function() {
  if (this.getToken() === null) {
    return false;
  }
  const now = new Date();
  const expiration = new Date(this.getData().exp * 1000);
  return now.getTime() < expiration.getTime();
};

JWT.getToken = function() {
  return localStorage.getItem("kithara.token");
};

JWT.getData = function() {
  const base64Url = this.getToken().split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(Buffer.from(base64, "base64").toString("binary"));
};

export default JWT;



// WEBPACK FOOTER //
// ./src/jwt.js